import { List } from 'immutable';
import { createSelector, defaultMemoize } from 'reselect';

import { isResourceLoading } from './common';

const isProductsLoading = defaultMemoize(isResourceLoading);
const getProducts = defaultMemoize(
    (data) => data.getIn(['products'], List()),
);

const getAllProductsData = (state) => state.getIn(['app', 'allProducts']);
const isAllProductsLoading = createSelector(getAllProductsData, isResourceLoading);
const getAllProducts = createSelector(getAllProductsData, (data) => data.get('products', List()).toJS());

const getDropdownProductsData = (state) => state.getIn(['app', 'dropdownProducts']);
const isDropdownProductsLoading = createSelector(getDropdownProductsData, isResourceLoading);
const getDropdownProducts = createSelector(getDropdownProductsData, (data) => data.get('products', List()).toJS());

export {
    isAllProductsLoading,
    isDropdownProductsLoading,
    isProductsLoading,
    getAllProducts,
    getDropdownProducts,
    getDropdownProductsData,
    getProducts,
};
